var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrintCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 251.91,
    height: 169.019,
    viewBox: "0 0 251.91 169.019",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_158",
    "data-name": "Groupe 158",
    transform: "translate(-24.4 0.002)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_78",
    "data-name": "Ellipse 78",
    cx: 37.91,
    cy: 37.91,
    r: 37.91,
    transform: "translate(56.953 91.567)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_84",
    "data-name": "Rectangle 84",
    width: 251.91,
    height: 0.586,
    transform: "translate(24.4 167.422)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_648",
    "data-name": "Trac\\xE9 648",
    d: "M863.773,294.115l-5.229-5.49s-5.752-8.628-9.935-6.275,6.013,7.844,6.013,7.844l5.229,8.628Z",
    transform: "translate(-635.7 -241.373)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_649",
    "data-name": "Trac\\xE9 649",
    d: "M922.816,735.5s3.922,7.582,1.046,8.1-16.994,1.307-17.256.523-2.353-3.4-.784-4.445,7.844-1.83,7.844-1.83l2.092-2.092Z",
    transform: "translate(-678.272 -576.346)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_650",
    "data-name": "Trac\\xE9 650",
    d: "M916.2,451.252s8.366,10.458,1.569,21.177L916.2,490.47s2.876,24.838-.784,33.2l-.523,2.876h-9.151l2.353-21.962s-.262-2.615-1.046-3.137-13.6-28.76-13.6-28.76,2.092-3.922,1.307-4.706.784-16.471,1.569-16.994S916.2,451.252,916.2,451.252Z",
    transform: "translate(-669.565 -366.091)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_651",
    "data-name": "Trac\\xE9 651",
    d: "M814.456,596.774l-1.046,6.013,10.2-.523-1.307-6.536Z",
    transform: "translate(-582.723 -439.975)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_79",
    "data-name": "Ellipse 79",
    cx: 7.844,
    cy: 7.844,
    r: 7.844,
    transform: "translate(225.72 34.44)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_652",
    "data-name": "Trac\\xE9 652",
    d: "M936.037,293.5l.784,9.412-8.366,3.922s1.438-8.759.392-11.112Z",
    transform: "translate(-695.415 -249.908)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_653",
    "data-name": "Trac\\xE9 653",
    d: "M902.59,322.558l.784-3.137,10.719-3.922s1.046,0,.784,1.83-.261,1.569-.261,1.569,3.66,1.569,3.922,4.183,4.445,3.4,4.183,7.321a13.891,13.891,0,0,1-1.569,6.013s1.307,3.137-.784,4.968c0,0-2.092,3.66-1.046,6.275s2.353,7.059-.523,6.275-22.746-2.092-22.746-2.092-2.876-10.719.261-14.641c0,0,0-2.353,2.353-7.059S902.59,322.558,902.59,322.558Z",
    transform: "translate(-670.595 -266.156)",
    fill: "#575a89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_654",
    "data-name": "Trac\\xE9 654",
    d: "M935.686,449.59s-3.4,14.38-7.582,15.948c0,0-.784,10.458-5.229,9.935s0-9.935,0-9.935l4.968-18.04Z",
    transform: "translate(-689.835 -363.644)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_655",
    "data-name": "Trac\\xE9 655",
    d: "M895.409,330.4s-3.922-6.275-4.968-5.229-6.275,4.183-6.013,6.275,2.615,2.092,2.615,2.092l5.49,4.183Z",
    transform: "translate(-662.892 -273.209)",
    fill: "#575a89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_656",
    "data-name": "Trac\\xE9 656",
    d: "M890.684,524.5l-3.137,2.255-2.092,22.321s7.582,30.328,9.674,30.59,10.719.261,10.458-.523a33.093,33.093,0,0,1-1.569-4.706c0-.784-2.727-7.057-2.727-7.057l-3.548-14.643.784-11.5Z",
    transform: "translate(-663.657 -420.513)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_657",
    "data-name": "Trac\\xE9 657",
    d: "M887.22,733.781s10.981-3.4,11.5-2.615,4.011,8.69-.871,9.574-22.4,2.453-22.4.1.523-3.922,2.092-3.922,8.628-3.4,9.151-4.183S887.22,733.781,887.22,733.781Z",
    transform: "translate(-656.272 -573.06)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_658",
    "data-name": "Trac\\xE9 658",
    d: "M913.092,253.756a.774.774,0,0,0-1.047-1.035l-.014.008a1.357,1.357,0,0,0-.638,1.357c-.943-.941-.248-2.827-1.267-3.685-.471-.4-1.237-.484-1.479-1.051-.141-.33-.045-.721-.169-1.058a1.533,1.533,0,0,0-1.3-.787,12.635,12.635,0,0,0-4.957.591,3.476,3.476,0,0,0-1.659.761,5.845,5.845,0,0,0-.9,1.714c-.281.585-2.122.532-2.766.449-.224-.636,1.429-.684,1.564-1.344.369-1.8-.915-3.724-.285-5.455a4.385,4.385,0,0,1,2.37-2.218,12.578,12.578,0,0,1,8.9-.759,1.976,1.976,0,0,1,.822.4c.38.355.45.924.7,1.378.577,1.035,1.944,1.28,2.866,2.024,1.4,1.126,1.554,3.159,1.6,4.952a6.1,6.1,0,0,1-.331,2.666,2.085,2.085,0,0,1-2.133,1.323C913.013,253.913,913.053,253.837,913.092,253.756Z",
    transform: "translate(-672.091 -210.957)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_659",
    "data-name": "Trac\\xE9 659",
    d: "M943.178,352.435a5.57,5.57,0,0,1,6.8.346c1.8,1.531,3.74,3.725,3.6,6-.261,4.183-1.83,21.439-3.922,21.7s-9.674-1.83-9.674-3.137,1.83-2.876,1.83-2.876l-2.222-13.333a8.813,8.813,0,0,1,3.472-8.612Z",
    transform: "translate(-703.542 -292.701)",
    fill: "#575a89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_660",
    "data-name": "Trac\\xE9 660",
    d: "M537.095,126.771H474.186A13.373,13.373,0,0,0,461.14,137.2L429.353,278.2a10.808,10.808,0,0,0,10.012,13.172l64.671,3.186a14.279,14.279,0,0,0,14.754-11.72l18.031-99.683,1.341.383,3.45-18.894-1.381-.345,5.033-27.825a8.234,8.234,0,0,0-8.17-9.7Z",
    transform: "translate(-326.608 -126.771)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_661",
    "data-name": "Trac\\xE9 661",
    d: "M500.444,138.4H493.1a9.242,9.242,0,0,0-9.03,7.272L453.56,285.51a5.727,5.727,0,0,0,5.22,6.935l64.462,4.225a7.417,7.417,0,0,0,7.784-6.086l26.035-144.54a6.5,6.5,0,0,0-6.393-7.647H543.7a3.066,3.066,0,0,0-2.96,2.268h0a2.706,2.706,0,0,1-2.613,2h-33.07a4.626,4.626,0,0,1-4.613-4.273Z",
    transform: "translate(-344.584 -135.357)",
    fill: "var(--second-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_85",
    "data-name": "Rectangle 85",
    width: 66.703,
    height: 0.329,
    transform: "translate(135.323 39.184)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_86",
    "data-name": "Rectangle 86",
    width: 67.36,
    height: 0.329,
    transform: "translate(132.695 49.863)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_662",
    "data-name": "Trac\\xE9 662",
    d: "M683.393,134.884l-1.516-2.021.263-.2,1.31,1.746,5.048-4.13.208.254Z",
    transform: "translate(-485.579 -96.22)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_663",
    "data-name": "Trac\\xE9 663",
    d: "M650.089,317.116l-1.516-2.021.263-.2,1.31,1.746,5.047-4.13.208.255Z",
    transform: "translate(-460.982 -230.808)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_87",
    "data-name": "Rectangle 87",
    width: 0.329,
    height: 69.84,
    transform: "translate(125.298 86.664) rotate(-88.787)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_88",
    "data-name": "Rectangle 88",
    width: 0.329,
    height: 71.157,
    transform: "matrix(0.023, -1, 1, 0.023, 123.162, 96.358)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_664",
    "data-name": "Trac\\xE9 664",
    d: "M586.863,556.292a15.608,15.608,0,0,1-31.216,0c0-.2,0-.389.012-.583a15.606,15.606,0,0,1,31.207.583Z",
    transform: "translate(-420.078 -432.251)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_665",
    "data-name": "Trac\\xE9 665",
    d: "M585.385,580.361c0,.2,0,.389-.012.583a15.61,15.61,0,0,1-29.725-6.662c0-.2,0-.389.012-.583a15.61,15.61,0,0,1,29.725,6.662Z",
    transform: "translate(-420.078 -450.242)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_666",
    "data-name": "Trac\\xE9 666",
    d: "M481.543,443.069l-5.548-7.4,1.314-.986,4.52,6.027,17.8-14.56,1.04,1.272Z",
    transform: "translate(-333.525 -314.734)",
    fill: "#f2f2f2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintCheck);
export default __webpack_public_path__ + "static/media/printCheck.ee5818d6.svg";
export { ForwardRef as ReactComponent };